class TokenService {
    getLocalRefreshToken() {
        const user = this.getUser();
        return user?.refreshToken;
    }
    getLocalAccessToken() {
        const user = this.getUser();
        return user?.accessToken;
    }
    updateLocalAccessToken(token) {
        const user = this.getUser();
        if (!user) {
            return;
        }
        user.accessToken = token;
        this.setUser(user);
    }
    getUser() {
        const raw = localStorage.getItem('user');
        if (!raw) {
            return null;
        }
        return JSON.parse(raw);
    }
    setUser(user) {
        localStorage.setItem('user', JSON.stringify(user));
    }
    removeUser() {
        localStorage.removeItem('user');
    }
}
export default new TokenService();
